// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowCard-cls1_49v","cls2":"BulkFollowCard-cls2_sQN BulkFollowCard-cls1_49v"};